import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const postFaqArticleLike = async (id: number | undefined) => {
  const response: AxiosResponse = await apiInstance.post(`/faq/${id}/like`);

  return response.data;
};
